<template>
  <div>
    <div class="navs">
      <div class="mains">
        <div class="l">
          <img src="@/assets/images/logo-1.png" alt="">
        </div>
        <div class="r">
          <div class="btn" @click="navShow">
            <img src="@/assets/images/navBtn.png" alt="">
          </div>
          <ul :class="navBtn ? 'on' : ''">
            <li @click="toNext(item.path)" :class="active == index ? 'on' : ''" v-for="(item,index) in list" :key="index">{{item.name}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ui-footer',
  data() {
    return {
      active: -1,
      list : [
        {
          name : '首页',
          path : '/home'
        },
        {
          name : '游戏中心',
          path : '/game'
        },
        {
          name : '活动中心',
          path : '/activity'
        },
        {
          name : '关于我们',
          path : '/about'
        },
        {
          name : '加入我们',
          path : '/add'
        }
      ],
      navBtn : false,
    }
  },
  created() {
  },
  mounted() {
    this.upactive()
  },

  methods: {
    upactive() {
      this.nowPath = this.$route.path;

      if(this.nowPath == '/activityDetail'){
        this.active = 2
      }
      if(this.nowPath == '/gameDetail'){
        this.active = 1
      }
      //vue提供的方法
      this.list.forEach( (item,index) => {
        if(item.path == this.nowPath){
          this.active = index;
        }
      })
    },
    toNext(path){
      if(this.$route.path != path){
        this.$router.push({
          path
        })
      }
      
    },
    navShow(){
      this.navBtn = !this.navBtn;
    }
  },
}
</script>
<style lang="less" scoped>
 .navs{
   width: 100%;
   height: 40px;
   font-size: 16px;
   background: #000;
   color: #fff;
 }
 .mains{
   max-width: 512px;
   height: 100%;
   margin: 0 auto;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }
 .l{
   width: 77px;
   height: 30px;
   img{
     width: auto;
     height: 100%;
   }
 }
 .r{
   width: 70%;
   display: flex;
   justify-content: flex-end;
   ul{
     display: flex;
     align-items: center;
     li{
       font-size: 10px;
       margin-left: 20px;
       font-weight: normal;
       cursor: pointer;
       &.on{
         color: #f48041;
       }
       &:hover{
         color: #f48041;
       }
     }
   }
   .btn{
     display: none;
   }
 }
 

  @media (max-width:800px) {
    .l{
      padding-left: 10px;
    }
    .r{
      .btn{
        display: block;
        width: 30px;
        height: 30px;
        padding-right: 10px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      ul{
        position: fixed;
        right: 0;
        top: 40px;
        z-index: 99;
        width: 100px;
        
        background: #000;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        display: none;
        
        &.on{
          display: block;
        }
        li{
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 13px;
        }
      }
    }
	}
</style>
